import "./Lockup.css";

// The ONE Juno lockup for every app surface (homepage, /desk, /console, invite accept). Single source
// of truth for the mark — DESIGN-MANIFEST §4 item 1. Drawn from juno-brand-assets/logo/juno-mark-*.svg
// and the §2 size table. The mark inverts with the theme via CSS custom properties (--markBg / --markFg,
// defined in Lockup.css); the green light is a LITERAL #00D47E and never a variable — it is the same on
// every background, in every theme, forever. One prop only: `size`. There is deliberately NO color prop
// (that is how the green light gets overridden by someone in a hurry). Legal pages and emails do NOT
// import this — they carry a hand-copied inline <svg> by rule.
const SIZES = {
  header: { mark: 28, word: 21, qualifier: "AGENTIC CRE", rule: true },
  // the console rail: the design's lockup is the mark and the word only — the ADMIN chip
  // beside it says which surface this is, so the AGENTIC CRE qualifier would be noise.
  rail: { mark: 26, word: 18, qualifier: "", rule: false },
  footer: { mark: 24, word: 0, qualifier: "JUNOCRE.COM", rule: false },
  "pre-account": { mark: 36, word: 27, qualifier: "", rule: false },
  email: { mark: 32, word: 24, qualifier: "", rule: false },
};

export function Lockup({ size = "header" }) {
  const cfg = SIZES[size] || SIZES.header;
  return (
    <span className={`juno-lockup juno-lockup--${size}`} data-testid="juno-lockup" aria-label="Juno">
      <svg className="juno-lockup__mark" width={cfg.mark} height={cfg.mark} viewBox="0 0 100 100"
           aria-hidden="true">
        <rect x="2" y="2" width="96" height="96" rx="12" style={{ fill: "var(--markBg, #ffffff)" }} />
        <path d="M58,34 V58 A16,16 0 0 1 26,58" fill="none" strokeWidth="14"
              style={{ stroke: "var(--markFg, #0D0D0F)" }} />
        <circle className="juno-lockup__dot" cx="58" cy="18" r="9" fill="#00D47E" />
      </svg>
      {cfg.word ? (
        <span className="juno-lockup__word" style={{ fontSize: cfg.word }}>Juno</span>
      ) : null}
      {cfg.rule ? <span className="juno-lockup__rule" /> : null}
      {cfg.qualifier ? <span className="juno-lockup__qual">{cfg.qualifier}</span> : null}
    </span>
  );
}
